import { useEffect, useState } from "react";
import { LAUNCH_DATE } from "../data/content";

function getRemaining() {
  const diff = new Date(LAUNCH_DATE).getTime() - Date.now();
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, live: true };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
    live: false,
  };
}

const Cell = ({ value, label }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${label}`}>
    <div className="font-display font-extrabold text-3xl md:text-5xl tabular-nums text-[#111827] bg-white rounded-2xl px-3 md:px-5 py-2 md:py-3 min-w-[64px] md:min-w-[96px] text-center shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-black/5">
      {String(value).padStart(2, "0")}
    </div>
    <span className="mt-2 text-[11px] md:text-xs font-bold uppercase tracking-[0.2em] text-[#4b5563]">
      {label}
    </span>
  </div>
);

const Countdown = () => {
  const [t, setT] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="countdown-timer"
      className="w-full flex flex-col items-center"
    >
      <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#58cc02] mb-5">
        {t.live ? "The mission has begun" : "Doors open 4 August 2026"}
      </p>
      <div className="flex items-end gap-2 md:gap-4">
        <Cell value={t.days} label="Days" />
        <span className="font-display font-extrabold text-3xl md:text-5xl text-[#d1d5db] pb-8">:</span>
        <Cell value={t.hours} label="Hours" />
        <span className="font-display font-extrabold text-3xl md:text-5xl text-[#d1d5db] pb-8">:</span>
        <Cell value={t.minutes} label="Mins" />
        <span className="font-display font-extrabold text-3xl md:text-5xl text-[#d1d5db] pb-8">:</span>
        <Cell value={t.seconds} label="Secs" />
      </div>
    </div>
  );
};

export default Countdown;
